import AxiosService from '../AxiosService';

const ExtendedTerms = async (clientCode: string): Promise<any> => {
  const instance = AxiosService.createProductsAxiosInstance();
  return instance.get('/client/extended-terms', {
    headers: {
      'Content-Type': 'multipart/form-data',
      'client-code': clientCode,
    },
  });
};

export default {
    ExtendedTerms,
    };